import ZealthCoinImg from './zealth-coin.webp'

const AppSplash = () => (
  <div
    role="status"
    aria-label="Loading"
    className="min-h-screen flex flex-col items-center justify-center gap-6 bg-background perspective-[800px]"
  >
    <img
      src={ZealthCoinImg}
      alt="Zealth"
      width={160}
      height={160}
      className="coin-flip"
    />
  </div>
)

export default AppSplash
